( function () {
	'use strict';

	/* @ngInject */
	function focusElement ( $timeout ) {
		function link ( scope, element ) {
			scope.$watch( 'focus', function ( value ) {
				if ( value ) {
					$timeout( function () {
						element[ 0 ].focus();
					}, 100 );
				}
			}, true );
		}

		var directive = {
			'link'     : link,
			'restrict' : 'A',
			'scope'    : {
				'focus' : '='
			}
		};

		return directive;
	}

	angular
		.module( 'app.components' )
		.directive( 'focusElement', focusElement );

	focusElement.$inject = [ '$timeout' ];
} )( );
